import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import './PageDetailPage.css';

function PageDetailPage() {
  const { pageId } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPage();
  }, [pageId]);

  const fetchPage = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      const pageRef = doc(db, 'pages', pageId);
      const pageSnap = await getDoc(pageRef);
      
      if (pageSnap.exists()) {
        setPage({ id: pageSnap.id, ...pageSnap.data() });
      } else {
        setError('Page not found');
      }
    } catch (err) {
      console.error('Error fetching page:', err);
      setError('Failed to load page');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="page-detail">
        <div className="page-loading">
          <div className="spinner"></div>
          <p>Loading page...</p>
        </div>
      </div>
    );
  }

  if (error || !page) {
    return (
      <div className="page-detail">
        <div className="page-error">
          <h2>⚠️ {error || 'Page not found'}</h2>
          <button onClick={() => navigate('/tools')} className="back-btn">
            Back to Tools
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="page-detail">
      <button onClick={() => navigate('/tools')} className="back-button">
        ← Back to Tools
      </button>

      {page.heroImageUrl && (
        <div className="page-hero">
          <img src={page.heroImageUrl} alt={page.title} className="page-hero-image" />
          <div className="page-hero-overlay"></div>
          <div className="page-hero-content">
            <h1>{page.title}</h1>
            {page.subtitle && <p className="page-subtitle">{page.subtitle}</p>}
          </div>
        </div>
      )}

      {!page.heroImageUrl && (
        <div className="page-header">
          <h1>{page.title}</h1>
          {page.subtitle && <p className="page-subtitle">{page.subtitle}</p>}
        </div>
      )}

      <div className="page-content">
        {page.content ? (
          <div 
            className="page-html-content"
            dangerouslySetInnerHTML={{ __html: page.content }}
          />
        ) : (
          <p className="no-content">No content available for this page.</p>
        )}
      </div>

      {page.updatedAt && (
        <div className="page-meta">
          <p>Last updated: {new Date(page.updatedAt.toDate()).toLocaleDateString()}</p>
        </div>
      )}
    </div>
  );
}

export default PageDetailPage;
